"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceBucketComponent = void 0;
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
//EXTERNAL LIBRARY BITS
const common_1 = require("@angular/common");
//INTERNAL LIBRARY BITS
const price_bucket_service_1 = require("./price-bucket.service");
//VARIABLE MODELS
const price_bucket_1 = require("./price-bucket");
const events_1 = require("./events");
let PriceBucketComponent = class PriceBucketComponent {
    constructor(_decimalPipe, _af, _cd, _priceBucket, document) {
        this._decimalPipe = _decimalPipe;
        this._af = _af;
        this._cd = _cd;
        this._priceBucket = _priceBucket;
        this.document = document;
        this.priceBucketScrollActive = false;
        this.pbEvent = new core_1.EventEmitter();
        this.priceBuckets = [];
        this.priceBucketMenu = { reset: false };
        setTimeout(() => {
            this.priceBucketNumberLine();
        }, 100);
    }
    addPriceBucket() {
        this.events.add({
            subFeature: events_1.EventSubFeature.priceBucket,
            action: events_1.EventAction.added
        });
        Promise.resolve(this.priceBuckets.push(new price_bucket_1.PriceBucket)).then(function () {
            $('html, div.priceBucketArray').animate({
                scrollLeft: document.getElementById("priceBucketContainer").scrollWidth
            }, 300);
        });
    }
    removePriceBucket(pb) {
        let priceBucket = this.priceBuckets[pb];
        this.events.add({
            subject: priceBucket.tier,
            subFeature: events_1.EventSubFeature.priceBucket,
            action: events_1.EventAction.deleted
        });
        this.priceBuckets.splice(pb, 1);
        this.priceBucketNumberLine();
    }
    priceBucketWidthCalc() {
        if (this.priceBucketContainerElement && this.priceBucketContainerElement.nativeElement &&
            (this.priceBucketContainerElement.nativeElement.offsetWidth < this.priceBucketContainerElement.nativeElement.scrollWidth)) {
            return this.priceBucketScrollActive = true;
        }
        return false;
    }
    resetPriceBuckets() {
        this.events.add({
            subFeature: events_1.EventSubFeature.priceBucket,
            action: events_1.EventAction.reset
        });
        this.priceBuckets = this._priceBucket.getDefault();
        this.cancelPriceBucketMenu();
        this._cd.markForCheck();
        this.pbEvent.emit(this.priceBuckets);
        setTimeout(() => {
            this.priceBucketNumberLine();
        }, 100);
        return true;
    }
    priceBucketSort(pb) {
        this.events.add({
            subFeature: events_1.EventSubFeature.priceBucket,
            action: events_1.EventAction.changed
        });
        while (-1) {
            if (this.priceBuckets[pb + 1] && (this.priceBuckets[pb + 1].tier < this.priceBuckets[pb].tier)) {
                this.priceBuckets.splice(pb, 2, this.priceBuckets[pb + 1], this.priceBuckets[pb]);
                pb = pb + 1;
                if (this.priceBuckets[pb + 1] && (this.priceBuckets[pb + 1].tier >= this.priceBuckets[pb].tier)) {
                    break;
                }
                continue;
            }
            else if (this.priceBuckets[pb - 1] && (this.priceBuckets[pb - 1].tier > this.priceBuckets[pb].tier)) {
                this.priceBuckets.splice(pb - 1, 2, this.priceBuckets[pb], this.priceBuckets[pb - 1]);
                pb = pb - 1;
                if (this.priceBuckets[pb - 1] && (this.priceBuckets[pb - 1].tier <= this.priceBuckets[pb].tier)) {
                    break;
                }
                continue;
            }
            break;
        }
        // Refresh the number line
        this.priceBucketNumberLine();
    }
    cancelPriceBucketMenu() {
        this.priceBucketMenu.reset = false;
        setTimeout(() => {
            this.priceBucketNumberLine();
        }, 100);
    }
    validPriceBuckets(pb) {
        for (let bucket of pb) {
            if (!bucket.tier || !bucket.pbi) {
                return false;
            }
        }
        return true;
    }
    priceBucketNumberLine() {
        function getWidth() {
            let width = d3.select("#priceBucketContainer").node().getBoundingClientRect()["width"];
            let minWidth = 400;
            let margin = width / 10; // 10% left & right margins
            return Math.max(width, minWidth) - margin;
        }
        // Avoid redrawing incomplete price buckets
        if (this.validPriceBuckets(this.priceBuckets)) {
            // Constants
            let w = getWidth();
            let h = 75;
            let linePadding = 8;
            let leftPadding = 30;
            let leftMargin = 5;
            let rightPadding = 60; // Aligns last major tick on the right of the number line
            let maxTicks = (w / this.priceBuckets.length) / 4; // Limit the amount of minor ticks
            // Create/replace number line svg element
            d3.select('#pbNumberLine').remove();
            let svg = d3.select("#pbNumberLineContainer")
                .append("svg")
                .attr("width", w)
                .attr("height", h)
                .attr("id", "pbNumberLine");
            // Calculate Ticks
            let ticks = [];
            let tickCount = 0;
            let prevCount = 0;
            for (let i = 0; i < this.priceBuckets.length; i++) {
                if (this.priceBuckets[i + 1]) {
                    prevCount += tickCount;
                    let increments = (this.priceBuckets[i + 1].tier - this.priceBuckets[i].tier) / this.priceBuckets[i].pbi;
                    tickCount = Math.ceil(Math.min(increments, maxTicks));
                    for (let j = 0; j <= tickCount; j++) {
                        let major = j === 0;
                        ticks.push({ "major": major, "tier": i, "count": tickCount, "prevCount": prevCount });
                    }
                }
                else {
                    // Add the final major tick
                    ticks.push({ "major": true, "tier": i, "count": 0 });
                }
            }
            // Draw Ticks
            let majorW = 3;
            let majorH = h * 0.7;
            let majorY = (h / 10) + (majorW / 2);
            let minorW = majorW / 3;
            let minorH = majorH / 1.5;
            let minorY = (h / 4) + (minorW / 2);
            let separation = ((w - rightPadding) / (this.priceBuckets.length - 1));
            let majorCount = 0;
            svg.selectAll("rect")
                .data(ticks)
                .enter()
                .append("rect")
                .attr("class", (d) => d["major"] === true ? "major" : "minor")
                .attr("x", (d, i) => {
                if (d["major"] === true) {
                    majorCount++;
                    return leftPadding + (d["tier"] * separation);
                }
                else {
                    let majorIndex = d["tier"];
                    let thisMajor = leftPadding + (majorIndex * separation);
                    let nextMajor = leftPadding + ((majorIndex + 1) * separation);
                    let innerIndex = i - (d["prevCount"] + majorCount) + 1;
                    return thisMajor + (innerIndex * ((nextMajor - thisMajor) / d["count"]));
                }
            })
                .attr("y", (d) => d["major"] === true ? majorY : minorY)
                .attr("width", (d) => d["major"] === true ? majorW : minorW)
                .attr("height", (d) => d["major"] === true ? majorH : minorH);
            // Draw Number Line
            svg.append("rect")
                .attr("x", leftMargin)
                .attr("y", h / 2)
                .attr("width", w - (minorW + linePadding))
                .attr("height", majorW)
                .attr("class", "numLine");
            // Draw Zero Tick
            svg.append("rect")
                .attr("x", leftMargin)
                .attr("y", majorY)
                .attr("width", majorW)
                .attr("height", majorH)
                .attr("class", "major");
            // Draw Right Arrow
            svg.append("path")
                .attr("transform", () => `translate(${w - linePadding}, ${(h / 2) + (majorW / 2)}) rotate(90)`)
                .attr("d", d3.symbol().type(d3.symbolTriangle))
                .attr("class", "numLineArrow");
            // Add Labels
            svg.selectAll("text")
                .data(this.priceBuckets)
                .enter()
                .append("text")
                .text((d) => { if (typeof d['tier'] == 'number') {
                return "$" + d["tier"].toFixed(2);
            }
            else if (typeof d['tier'] == 'string') {
                return "$" + JSON.parse(d['tier']).toFixed(2);
            } })
                .attr("x", (d, i) => (leftPadding / 4) + (i * separation))
                .attr("y", h * .99)
                .attr("class", "numLineLabel");
        }
        // Redraw on resize
        d3.select(window).on('resize', function () {
            this._af.tick();
        }.bind(this));
        this.pbEvent.emit(this.priceBuckets);
    }
};
exports.PriceBucketComponent = PriceBucketComponent;
__decorate([
    (0, core_1.ViewChild)('priceBucketContainer'),
    __metadata("design:type", core_1.ElementRef)
], PriceBucketComponent.prototype, "priceBucketContainerElement", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], PriceBucketComponent.prototype, "pbEvent", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], PriceBucketComponent.prototype, "priceBuckets", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", events_1.ControlCenterEvents)
], PriceBucketComponent.prototype, "events", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], PriceBucketComponent.prototype, "priceBucketMenu", void 0);
exports.PriceBucketComponent = PriceBucketComponent = __decorate([
    (0, core_1.Component)({
        selector: 'price-bucket-menu',
        templateUrl: 'app/price-bucket.component.html',
    }),
    __param(4, (0, core_1.Inject)(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [common_1.DecimalPipe,
        core_1.ApplicationRef,
        core_1.ChangeDetectorRef,
        price_bucket_service_1.PriceBucketService,
        Document])
], PriceBucketComponent);
//# sourceMappingURL=price-bucket.component.js.map